<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Shipping Summary</h4>
        </div>
        <div class="card-body">
          <div class="row summary-info">
            <div class="col-12 col-sm-12">
              <span>
                <small class="text-muted text-uppercase">Shipping Units</small><br>{{ rows.length }}
              </span>
              <span>
                <small class="text-muted text-uppercase">Density</small><br>{{ densityStr }}
              </span>
              <span>
                <small class="text-muted text-uppercase">Class</small><br>{{ densityClass }}
              </span>
              <span>
                <small class="text-muted text-uppercase">Total Weight</small><br>{{ totalWeight + ' lbs (' + totalWeightKgs + ' kgs)'}}
              </span>
            </div>
          </div>

          <table class="table table-sm">
            <thead>
              <tr>
                <th>Description</th>
                <th class="text-center">Quantity</th>
                <th class="text-center">Hazardous</th>
                <th class="text-center">Shipping Unit(s)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, shipIndex) in flattenRows">
                <tr :key="'shipunit_'+shipIndex">
                  <td class="form-group" :style="{position: 'relative'}">
                    <span>{{row.description}}</span>
                  </td>
                  <td class="text-center" style="max-width: 80px">
                    <span :class="{shiphide: false}">{{row.quantity}}</span>
                  </td>
                  <td class="text-center" style="max-width: 80px">
                    <span>{{row.hazardous}}</span>
                  </td>
                  <td class="text-center" style="max-width: 80px">
                    <span>{{row.shippingUnits.join(', ')}}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ThreeDots } from "vue-loading-spinner";

const LB_TO_KG = 0.45359237;

export default {
  name: "ShippingSummary",
  components: {
    ThreeDots,
  },
  props: ['title', 'readonly', 'rfq', 'rows'],
  data: () => ({
    loading: false,
  }),
  mounted () {
  },
  computed: {

    density() {

      console.log('calculating density');
      console.log(this.rows);

      // Get and Sum All Variables
      var rowlen = this.rows.length

      // convert everything to inches and pounds
      var totalVolume = 0; // inches
      let totalWeight = 0; // pounds

      for (var j = 0; j < rowlen; j++) {

        // convert to inches and pounds
        var itemQuantity = parseInt(this.rows[j].quantity);
        var itemWeight = parseFloat(this.rows[j].weight || 0);
        var itemWidth = parseFloat(this.rows[j].width);
        var itemHeight = parseFloat(this.rows[j].height);
        var itemLength = parseFloat(this.rows[j].length);
        if (this.rows[j].unitlength === 'cm') {
          itemHeight /= 2.54
          itemLength /= 2.54
          itemWidth /= 2.54
        }
        else if (this.rows[j].unitlength === 'm') {
          itemHeight /= 0.0254
          itemLength /= 0.0254
          itemWidth /= 0.0254
        }
        else if (this.rows[j].unitlength === 'ft') {
          itemHeight *= 12
          itemLength *= 12
          itemWidth *= 12
        }
        if (this.rows[j].unitweight === 'kgs') {
          totalWeight += ((itemWeight / LB_TO_KG) * itemQuantity)
        } else {
          totalWeight += (itemWeight * itemQuantity)
        }

        totalVolume += (itemWidth*itemHeight*itemLength*itemQuantity)
      }

      if (totalWeight == '' || totalWeight == 0) {
        return 0;
      }

      // Calculate Density in cubic feet
      var cubicfeet = totalVolume / 1728;
      var finalDensity = Math.round((totalWeight / cubicfeet) * 100) / 100;
      totalWeight = Math.round(totalWeight * 10) / 10;
      return finalDensity || 0;
    },

    totalWeight() {
      console.log('totalWeight()');
      var rowlen = this.rows.length;

      // convert to pounds
      let totalWeight = 0;
      for (var j = 0; j < rowlen; j++) {
        var itemQuantity = parseInt(this.rows[j].quantity);
        var itemWeight = parseFloat(this.rows[j].weight) || 0;
        if (this.rows[j].unitweight === 'kgs') {
          totalWeight += ((itemWeight / LB_TO_KG) * itemQuantity)
        } else {
          totalWeight += (itemWeight * itemQuantity)
        }
      }

      totalWeight = Math.round(totalWeight * 10) / 10;
      this.rfq.totalWeight =totalWeight;
      return totalWeight || 0;
    },

    totalWeightKgs() {
      const kgs = this.totalWeight * LB_TO_KG;
      this.rfq.totalWeightKg = kgs;
      return Math.round(kgs * 10) / 10;
    },

    densityStr() {
      const finalDensity = Math.round(this.density * 10) / 10;
      if (isNaN(finalDensity)) 
        this.rfq.density = 'N/A';
      else
        this.rfq.density = finalDensity.toString() + ' lbs per cubic feet'
      return this.rfq.density;
    },

    densityClass() {
      const finalDensity = this.density;
      let densityClass = 'N/A';
      if (isNaN(finalDensity) || finalDensity == 0) {
        densityClass = 'N/A'
      } else {
        if (finalDensity < 1) {
          densityClass = '400'
        } else if (finalDensity < 2) {
          densityClass = '300'
        } else if (finalDensity < 4) {
          densityClass = '250'
        } else if (finalDensity < 6) {
          densityClass = '150'
        } else if (finalDensity < 8) {
          densityClass = '125'
        } else if (finalDensity < 10) {
          densityClass = '100'
        } else if (finalDensity < 12) {
          densityClass = '92.5'
        } else if (finalDensity < 15) {
          densityClass = '85'
        } else {
          densityClass = '75'
        }
      }
      this.rfq.densityClass = densityClass;
      return densityClass;
    },

    flattenRows() {
      let rollupObj = {};
      console.log('loading shipping summary');
      this.rows.map((row, i) => {

        let quantityMultiplier = Number(row.quantity) || 0;

        const isHoldingSecondaryUnits = Array.isArray(row.components) && row.components.length > 0;
        if (!isHoldingSecondaryUnits) {
          if (rollupObj.hasOwnProperty(row.description)) {
            rollupObj[row.description].quantity += quantityMultiplier;
            rollupObj[row.description].shippingUnits.push(`${i + 1}`);
          } else {
            rollupObj[row.description] = {
              description: row.description,
              quantity: quantityMultiplier,
              hazardous: row.hazardous,
              shippingUnits: [`${i + 1}`]
            }
          }
        } else {
          row.components.map((secondaryUnit) => {

            const secondaryQuantity = (secondaryUnit.quantity || 0)*quantityMultiplier;
            const shippingUnits = [];
            
            // roll up unit descriptions fron all non-containers (ie products only)
            // products can appear at either the secondary or primary level
            const isHoldingPrimaryUnits = Array.isArray(secondaryUnit.components) && secondaryUnit.components.length > 0;
            if (isHoldingPrimaryUnits) {
              for (let p = 0; p < secondaryUnit.components.length; p++) {
                const primaryQuantity = secondaryUnit.components[p].quantity * secondaryQuantity;
                if (rollupObj.hasOwnProperty(secondaryUnit.components[p].description)) {
                  rollupObj[secondaryUnit.components[p].description].quantity += primaryQuantity;
                } else {
                  rollupObj[secondaryUnit.components[p].description] = {
                    description: secondaryUnit.components[p].description,
                    quantity: primaryQuantity,
                    hazardous: secondaryUnit.components[p].hazardous,
                    shippingUnits: [`${i + 1}`]
                  }
                }

                // prevent duplicate shipping units
                if (!rollupObj[secondaryUnit.components[p].description].shippingUnits.includes(`${i + 1}`)) {
                  rollupObj[secondaryUnit.components[p].description].shippingUnits.push(`${i + 1}`);
                }
              }
            } else {
              // this secondary unit is not a container, roll it up
              if (rollupObj.hasOwnProperty(secondaryUnit.description)) {
                rollupObj[secondaryUnit.description].quantity += secondaryQuantity;
              } else {
                rollupObj[secondaryUnit.description] = {
                  description: secondaryUnit.description,
                  quantity: secondaryQuantity,
                  hazardous: secondaryUnit.hazardous,
                  shippingUnits: [`${i + 1}`]
                }
              }

              // prevent duplicate shipping units
              if (!rollupObj[secondaryUnit.description].shippingUnits.includes(`${i + 1}`)) {
                rollupObj[secondaryUnit.description].shippingUnits.push(`${i + 1}`);
              }
            }

          });
        }

      });
      return Object.keys(rollupObj).map(key => rollupObj[key]);
    }
  },
  methods: {
  },
};
</script>

<style scoped>
  .su-group-addon {
    background-color: #eee !important;
    border: 1px solid #ccc !important;
  }
  .summary-info span {
    display: inline-block;
    margin-right: 2.5em;
    min-width: 50px;
    margin-left: 1em;
  }
</style>


// WEBPACK FOOTER //
// ShippingSummary.vue?049b89f4